module.exports = __webpack_public_path__ + "img/Boule_papier.64b2e7b.jpg";